import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { ClusterApprovalRequest } from '../../types/cluster'
import api from '../../api'

const useAcceptCluster = (clusterID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (clusterApproval: ClusterApprovalRequest) => {
			return api.clusters.acceptCluster(clusterApproval)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['clusters'] })
			queryClient.invalidateQueries({ queryKey: ['cluster', clusterID] })
		}
	})
}

export default useAcceptCluster
